/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, day: NonNullable<unknown> }} Progress_Body_Weight_RangeInputs */

const en_us2_progress_body_weight_range = /** @type {(inputs: Progress_Body_Weight_RangeInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 entry · ${i?.day}`);
	return /** @type {LocalizedString} */ (`${i?.count} entries · ${i?.day}`)
	
};

const pt_br2_progress_body_weight_range = /** @type {(inputs: Progress_Body_Weight_RangeInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 registro · ${i?.day}`);
	return /** @type {LocalizedString} */ (`${i?.count} registros · ${i?.day}`)
	
};

const es_419_progress_body_weight_range = /** @type {(inputs: Progress_Body_Weight_RangeInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 registro · ${i?.day}`);
	return /** @type {LocalizedString} */ (`${i?.count} registros · ${i?.day}`)
	
};

const pt_pt2_progress_body_weight_range = /** @type {(inputs: Progress_Body_Weight_RangeInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 registo · ${i?.day}`);
	return /** @type {LocalizedString} */ (`${i?.count} registos · ${i?.day}`)
	
};

const fr_fr2_progress_body_weight_range = /** @type {(inputs: Progress_Body_Weight_RangeInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 pesée · ${i?.day}`);
	return /** @type {LocalizedString} */ (`${i?.count} pesées · ${i?.day}`)
	
};

const de_de2_progress_body_weight_range = /** @type {(inputs: Progress_Body_Weight_RangeInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Eintrag · ${i?.day}`);
	return /** @type {LocalizedString} */ (`${i?.count} Einträge · ${i?.day}`)
	
};

const it_it2_progress_body_weight_range = /** @type {(inputs: Progress_Body_Weight_RangeInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 registrazione · ${i?.day}`);
	return /** @type {LocalizedString} */ (`${i?.count} registrazioni · ${i?.day}`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 entry · {day}" |
* | * | "{count} entries · {day}" |
*
* @param {Progress_Body_Weight_RangeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_body_weight_range = /** @type {((inputs: Progress_Body_Weight_RangeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Body_Weight_RangeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_body_weight_range(inputs)
	if (locale === "es-419") return es_419_progress_body_weight_range(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_body_weight_range(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_body_weight_range(inputs)
	if (locale === "de-DE") return de_de2_progress_body_weight_range(inputs)
	if (locale === "it-IT") return it_it2_progress_body_weight_range(inputs)
	return en_us2_progress_body_weight_range(inputs)
});
export { progress_body_weight_range as "progress.body_weight_range" }